import LatLngBounds = google.maps.LatLngBounds;
import LatLngBoundsLiteral = google.maps.LatLngBoundsLiteral;

export class MapPosition {
  lat: number;
  lng: number;
  zoom?: number;
  fitBounds?: LatLngBounds;
  fitBoundsLiteral?: LatLngBoundsLiteral;
}
